module.exports = __webpack_public_path__ + "assets/play.svg?4589493427989c55021df56ac6623e6b";